/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
/** @packageDocumentation
 * @module SnapMode
 */

import "./Indicator.scss";
import classnames from "classnames";
import * as React from "react";
import type { FooterIndicatorProps } from "../Indicator";
import { FooterIndicator } from "../Indicator";

/** Properties of [[SnapMode]] component.
 * @internal
 */
export interface SnapModeProps extends FooterIndicatorProps {
  /** Indicator label. */
  children?: string;
  /** Indicator icon. */
  icon?: React.ReactNode;
  /** Clickable part of the indicator. */
  indicatorRef?: React.Ref<HTMLDivElement>;
  /** Function called when indicator is clicked. */
  onClick?: () => void;
}

/** Snap mode indicator used in [[Footer]] component. Used with [[SnapModePanel]] component.
 * @note Use [SnapModeField]($appui-react) instead
 * @internal
 */
export class SnapMode extends React.PureComponent<SnapModeProps> {
  public override render() {
    const { children, className, icon, indicatorRef, onClick, ...props } =
      this.props;
    return (
      <FooterIndicator
        className={classnames("nz-footer-snapMode-indicator", className)}
        {...props}
      >
        <div // eslint-disable-line jsx-a11y/click-events-have-key-events
          className="nz-indicator"
          onClick={onClick}
          ref={indicatorRef}
          role="button"
          tabIndex={-1}
        >
          {children !== undefined && (
            <span className="nz-label">{children}</span>
          )}
          <div className="nz-icon">{icon}</div>
        </div>
      </FooterIndicator>
    );
  }
}
